module.exports = __webpack_public_path__ + "0c7737e5b274620ec24c94034df66953.svg";